import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { CustomValidators } from 'shared/validation/custom-validators';

/* eslint-disable */
export const coreSegmentData: any = [
    {
       'field_map': 'id',
       'item_name': 'id',
       'title': 'Id',
       'hint_detail': 'Id',
       'hint_panel' : 'Id',
       'example': '',
       'sequence': 1,
       'show_more': true,
       'lookup': null
    },
    {
        'field_map': 'name',
        'item_name': 'name',
        'title': 'Name',
        'hint_detail': 'Name',
        'hint_panel' : 'Name',
        'example': '',
        'sequence': 2,
        'show_more': true,
        'lookup': null,
        'validation': {
          'PIES_6_5': {
            maxLength: 100,
            required: true,
            message: 'Name must be provided and may not be longer than 100 characters'
          },
        },
    },
    {
        'field_map': 'class',
        "item_name": "class",
        "title": "Core Class",
        "hint_detail": "Core Class",
        "hint_panel" : "Core Class",
        "example": "CORECLS1",
        "sequence": 3,
        "show_more": true,
        'validation': {
            'PIES_6_5': {
                maxLength: 8,
                custom: function (): ValidatorFn {
                  return (control: AbstractControl): {[key: string]: any} => {
                    if (control.value && !control.value.match(/^[a-z0-9\s]+$/i)) {
                      return {'class': 'Cannot contain special characters'};
                    }
                    return null;
                  };
                },
                message: 'Core Class is limited to 8 characters, no special characters allowed.'
            },
        },
        "lookup": null
    },
    {
        'field_map': 'group',
        "item_name": "group",
        "title": "Core Group",
        "hint_detail": "Core Group",
        "hint_panel" : "Core Group",
        "example": "COREGRP1",
        "sequence": 4,
        "show_more": true,
        'validation': {
            'PIES_6_5': {
                maxLength: 8,
                custom: function (): ValidatorFn {
                  return (control: AbstractControl): {[key: string]: any} => {
                    if (control.value && !control.value.match(/^[a-z0-9\s]+$/i)) {
                      return {'group': 'Cannot contain special characters'};
                    }
                    return null;
                  };
                },
                message: 'Core Group is limited to 8 characters, no special characters allowed.'
            },
        },
        "lookup": null
    },
    {
        'field_map': 'days',
        "item_name": "days",
        "title": "Expiration Days",
        "hint_detail": "Core Return Days to Expiry",
        "hint_panel" : "Core Return Days to Expiry",
        "example": "",
        "sequence": 5,
        "show_more": true,
        "lookup": null,
        'numerical': true,
        'validation': {
            'PIES_6_5': {
                validator: Validators.compose([CustomValidators.digits, CustomValidators.lte(999)]),
                message: 'Expiration days cannot exceed 999 days and cannot have Alphabetical characters.'
            },
        },
    }
];
/* eslint-enable */
